export const sickLeaveLookup = {
  0: [
    0, 169, 343, 517, 691, 865, 1039, 1213, 1387, 1560, 1734, 1908, 2082, 2256,
    2430, 2604, 2778, 2952, 3126, 3300, 3474, 3647, 3821, 3995, 4169,
  ],
  1: [
    1, 175, 349, 523, 697, 871, 1045, 1218, 1392, 1566, 1740, 1914, 2088, 2262,
    2436, 2610, 2784, 2958, 3132, 3305, 3479, 3653, 3827, 4001, 4175,
  ],
  2: [
    7, 181, 355, 529, 702, 876, 1050, 1224, 1398, 1572, 1746, 1920, 2094, 2268,
    2442, 2616, 2789, 2963, 3137, 3311, 3485, 3659, 3833, 4007, 4181,
  ],
  3: [
    13, 187, 360, 534, 708, 882, 1056, 1230, 1404, 1578, 1752, 1926, 2100, 2274,
    2447, 2621, 2795, 2969, 3143, 3317, 3491, 3665, 3839, 4013, 4187,
  ],
  4: [
    18, 192, 366, 540, 714, 888, 1062, 1236, 1410, 1584, 1758, 1931, 2105, 2279,
    2453, 2627, 2801, 2975, 3149, 3323, 3497, 3671, 3845, 4018, 4192,
  ],
  5: [
    24, 198, 372, 546, 720, 894, 1068, 1242, 1416, 1589, 1763, 1937, 2111, 2285,
    2459, 2633, 2807, 2981, 3155, 3329, 3503, 3676, 3850, 4024, 4198,
  ],
  6: [
    30, 204, 378, 552, 726, 900, 1073, 1247, 1421, 1595, 1769, 1943, 2117, 2291,
    2465, 2639, 2813, 2987, 3160, 3334, 3508, 3682, 3856, 4030, 4204,
  ],
  7: [
    36, 210, 384, 558, 731, 905, 1079, 1253, 1427, 1601, 1775, 1949, 2123, 2297,
    2471, 2645, 2818, 2992, 3166, 3340, 3514, 3688, 3862, 4036, 4210,
  ],
  8: [
    42, 215, 389, 563, 737, 911, 1085, 1259, 1433, 1607, 1781, 1955, 2129, 2302,
    2476, 2650, 2824, 2998, 3172, 3346, 3520, 3694, 3868, 4042, 4216,
  ],
  9: [
    47, 221, 395, 569, 743, 917, 1091, 1265, 1439, 1613, 1787, 1960, 2134, 2308,
    2482, 2656, 2830, 3004, 3178, 3352, 3526, 3700, 3874, 4047, 4221,
  ],
  10: [
    53, 227, 401, 575, 749, 923, 1097, 1271, 1445, 1618, 1792, 1966, 2140, 2314,
    2488, 2662, 2836, 3010, 3184, 3358, 3532, 3705, 3879, 4053, 4227,
  ],
  11: [
    59, 233, 407, 581, 755, 929, 1102, 1276, 1450, 1624, 1798, 1972, 2146, 2320,
    2494, 2668, 2842, 3016, 3189, 3363, 3537, 3711, 3885, 4059, 4233,
  ],
  12: [
    65, 239, 413, 587, 760, 934, 1108, 1282, 1456, 1630, 1804, 1978, 2152, 2326,
    2500, 2674, 2847, 3021, 3195, 3369, 3543, 3717, 3891, 4065, 4239,
  ],
  13: [
    71, 244, 418, 592, 766, 940, 1114, 1288, 1462, 1636, 1810, 1984, 2158, 2331,
    2505, 2679, 2853, 3027, 3201, 3375, 3549, 3723, 3897, 4071, 4245,
  ],
  14: [
    76, 250, 424, 598, 772, 946, 1120, 1294, 1468, 1642, 1816, 1989, 2163, 2337,
    2511, 2685, 2859, 3033, 3207, 3381, 3555, 3729, 3903, 4076, 4250,
  ],
  15: [
    82, 256, 430, 604, 778, 952, 1126, 1300, 1473, 1647, 1821, 1995, 2169, 2343,
    2517, 2691, 2865, 3039, 3213, 3387, 3560, 3734, 3908, 4082, 4256,
  ],
  16: [
    88, 262, 436, 610, 784, 958, 1131, 1305, 1479, 1653, 1827, 2001, 2175, 2349,
    2523, 2697, 2871, 3045, 3218, 3392, 3566, 3740, 3914, 4088, 4262,
  ],
  17: [
    94, 268, 442, 616, 789, 963, 1137, 1311, 1485, 1659, 1833, 2007, 2181, 2355,
    2529, 2703, 2876, 3050, 3224, 3398, 3572, 3746, 3920, 4094, 4268,
  ],
  18: [
    100, 273, 447, 621, 795, 969, 1143, 1317, 1491, 1665, 1839, 2013, 2187,
    2360, 2534, 2708, 2882, 3056, 3230, 3404, 3578, 3752, 3926, 4100, 4274,
  ],
  19: [
    105, 279, 453, 627, 801, 975, 1149, 1323, 1497, 1671, 1845, 2018, 2192,
    2366, 2540, 2714, 2888, 3062, 3236, 3410, 3584, 3758, 3932, 4105, 4279,
  ],
  20: [
    111, 285, 459, 633, 807, 981, 1155, 1329, 1502, 1676, 1850, 2024, 2198,
    2372, 2546, 2720, 2894, 3068, 3242, 3416, 3589, 3763, 3937, 4111, 4285,
  ],
  21: [
    117, 291, 465, 639, 813, 987, 1160, 1334, 1508, 1682, 1856, 2030, 2204,
    2378, 2552, 2726, 2900, 3074, 3247, 3421, 3595, 3769, 3943, 4117, 4291,
  ],
  22: [
    123, 297, 471, 644, 818, 992, 1166, 1340, 1514, 1688, 1862, 2036, 2210,
    2384, 2558, 2731, 2905, 3079, 3253, 3427, 3601, 3775, 3949, 4123, 4297,
  ],
  23: [
    129, 302, 476, 650, 824, 998, 1172, 1346, 1520, 1694, 1868, 2042, 2216,
    2389, 2563, 2737, 2911, 3085, 3259, 3433, 3607, 3781, 3955, 4129, 4303,
  ],
  24: [
    134, 308, 482, 656, 830, 1004, 1178, 1352, 1526, 1700, 1874, 2047, 2221,
    2395, 2569, 2743, 2917, 3091, 3265, 3439, 3613, 3787, 3961, 4134, 4308,
  ],
  25: [
    140, 314, 488, 662, 836, 1010, 1184, 1358, 1531, 1705, 1879, 2053, 2227,
    2401, 2575, 2749, 2923, 3097, 3271, 3445, 3618, 3792, 3966, 4140, 4314,
  ],
  26: [
    146, 320, 494, 668, 842, 1016, 1189, 1363, 1537, 1711, 1885, 2059, 2233,
    2407, 2581, 2755, 2929, 3103, 3276, 3450, 3624, 3798, 3972, 4146, 4320,
  ],
  27: [
    152, 326, 500, 673, 847, 1021, 1195, 1369, 1543, 1717, 1891, 2065, 2239,
    2413, 2587, 2760, 2934, 3108, 3282, 3456, 3630, 3804, 3978, 4152, 4326,
  ],
  28: [
    158, 331, 505, 679, 853, 1027, 1201, 1375, 1549, 1723, 1897, 2071, 2245,
    2418, 2592, 2766, 2940, 3114, 3288, 3462, 3636, 3810, 3984, 4158, 4332,
  ],
  29: [
    163, 337, 511, 685, 859, 1033, 1207, 1381, 1555, 1729, 1902, 2076, 2250,
    2424, 2598, 2772, 2946, 3120, 3294, 3468, 3642, 3816, 3989, 4163, 4337,
  ],
}
